import { getFirestoreData } from "./getFirestoreData";

export async function loadUser(id) {
	try {
		const user = await getFirestoreData("users", id);
		return user;
	} catch (error) {}
}
